import React from "react";
import { Link, useLocation, matchPath } from "react-router";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";

const NavItem = ({
  to,
  title,
  icon: Icon,
  open,
  onClick,
  end,
  isActiveFn,
}) => {
  const location = useLocation();
  const pathMatch = end
    ? location.pathname === to
    : matchPath({ path: to, end: false }, location.pathname) != null;
  const isActive = isActiveFn ? isActiveFn(pathMatch) : pathMatch;

  return (
    <Tooltip
      arrow
      placement="right"
      title={open ? "" : title}
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 200 }}
    >
      <Box
        component={Link}
        to={to}
        onClick={onClick}
        className={isActive ? "active" : undefined}
        sx={{
          display: "block",
          color: "text.secondary",
          textDecoration: "none",
          mx: 0.5,
          mb: 0.5,
          "& .MuiListItem-root": {
            borderRadius: 3,
            transition: "all 0.2s ease-in-out",
          },
          "& .MuiListItemIcon-root": {
            transition: "color 0.2s ease-in-out",
          },
          "&:hover .MuiListItem-root": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
            color: "primary.main",
          },
          "&:hover .MuiListItemIcon-root": {
            color: "primary.main",
          },
          "&.active": {
            color: "primary.main",
            "& .MuiListItem-root": {
              backgroundColor: "white",
              color: "primary.main",
              borderRadius: 3,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            },
            "& .MuiListItemIcon-root": {
              color: "primary.main",
            },
            "& .MuiListItemText-primary": {
              fontWeight: "fontWeightMedium",
            },
          },
        }}
      >
        <ListItem
          sx={{
            display: "flex",
            paddingRight: 1,
            cursor: "pointer",
          }}
        >
          <ListItemIcon sx={{ minWidth: 30, marginRight: "20px" }}>
            <Icon />
          </ListItemIcon>

          <ListItemText primary={title} sx={{ margin: 0 }} />
        </ListItem>
      </Box>
    </Tooltip>
  );
};

export default NavItem;
